import { gql } from 'glimmer-apollo';

// Comprehensive query for all esports index widgets
export const ESPORTS_WIDGETS_QUERY = gql`
  query EsportsWidgets {
    # Get teams for standings widget  
    teams(limit: 5) {
      name
      slug
      country
      logo {
        url(width: 48, height: 48, fit: cover, format: webp)
      }
      matches {
        victor {
          slug
        }
      }
    }
    
    # Get latest completed match
    latestMatch: matches(
      limit: 1, 
      where: { isLive: false, isFinal: true }
      orderBy: SCHEDULED_DATE_DESC
    ) {
      title
      slug
      scheduledDate
      teams {
        name
        slug
        country
        logo {
          url(width: 64, height: 64, fit: cover, format: webp)
        }
      }
      rounds {
        team1Score
        team2Score
        stats {
          kills
          deaths
          assists
        }
      }
      tournament {
        name
        slug
      }
    }
    
    # Get top players
    topPlayers: players(limit: 5, orderBy: KDA_DESC) {
      gamertag
      slug
      irlName
      kda
      winRate
      gamesPlayed
      totalKills
      totalDeaths
      photo {
        url(width: 80, height: 80, fit: cover, format: webp)
      }
      currentTeam {
        name
        slug
        country
        logo {
          url(width: 48, height: 48, fit: cover, format: webp)
        }
      }
    }
    
    # Get upcoming matches
    upcomingMatches: matches(
      limit: 3,
      where: { scheduledDate_gt: "now" }
      orderBy: SCHEDULED_DATE_ASC
    ) {
      title
      slug
      scheduledDate
      teams {
        name
        slug
        country
        logo {
          url(width: 48, height: 48, fit: cover, format: webp)
        }
      }
      tournament {
        name
        slug
      }
    }
    
    # Get live match
    liveMatch: matches(
      limit: 1,
      where: { isLive: true }
    ) {
      title
      slug
      isLive
      liveTime
      teams {
        name
        slug
        country
        score
        logo {
          url(width: 64, height: 64, fit: cover, format: webp)
        }
      }
      tournament {
        name
        slug
        liveVideoUrl
        liveChatUrl
      }
    }
  }
`;
